import { Site } from '@envato/foundation-types'

import { getConfigBySite } from '../../../config/sites'
import { Consent } from '../consent'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../localStorageHelpers'

const getLocalStorageKey = (site: Site, pageType: string) => {
  return `${site}-${pageType}-page-views`
}

const incrementPageViewCount = (site: Site, pageType: string) => {
  const key = getLocalStorageKey(site, pageType)
  const newCount = getLocalStorageItem(key, Consent.statistics, 0) + 1
  setLocalStorageItem(key, newCount, Consent.statistics)
}

export const shouldTrackPageViewCount = (site: Site, pageType: string) => {
  return !!getConfigBySite(site, `surveys.${pageType}`)
}

export const getPageViewCount = (site: Site, pageType: string) =>
  getLocalStorageItem(getLocalStorageKey(site, pageType), Consent.statistics, 0)

export const trackPageViewFor = (site: Site, pageType: string) => {
  if (shouldTrackPageViewCount(site, pageType)) {
    incrementPageViewCount(site, pageType)
  }
}
